var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "frame", staticClass: "frame" }, [
    _vm.isCampaign
      ? _c("div", {
          staticClass: "campaign-header",
          domProps: { innerHTML: _vm._s(_vm.$t("agentIntro.campaignHeader")) },
        })
      : _vm._e(),
    _c(
      "div",
      { ref: "container", staticClass: "container" },
      [
        _vm.isCampaign
          ? [
              _c("div", { staticClass: "top-info" }, [
                _vm._v(_vm._s(_vm.$t("agentIntro.campaignTopInfo"))),
              ]),
              _c("h1", { staticClass: "top-title" }, [
                _vm._v(_vm._s(_vm.$t("agentIntro.campaignTopTitle"))),
              ]),
              _c("img", {
                staticClass: "campaign-image",
                attrs: { src: require("@/assets/img/agent/handshake.webp") },
              }),
            ]
          : [
              _c("div", { staticClass: "top-info" }, [
                _vm._v(_vm._s(_vm.$t("agentIntro.defaultTopInfo"))),
              ]),
              _c("h1", {
                staticClass: "top-title",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("agentIntro.defaultTopTitle")),
                },
              }),
            ],
        _c("div", {
          staticClass: "intro",
          domProps: { innerHTML: _vm._s(_vm.$t("agentIntro.introText")) },
        }),
        _vm.isIntro && _vm.isLoadCMS && _vm.isAgentFeatureNotAgreed
          ? _c("div", { staticClass: "item-box" }, [
              _c(
                "button",
                {
                  staticClass: "button submit",
                  on: { click: _vm.ctaTopClicked },
                },
                [_vm._v(_vm._s(_vm.detail.ctaTopBtnText))]
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "item-box" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("agentIntro.commercializationTitle"))),
          ]),
          _c("div", { staticClass: "commercial" }, [
            _c("div", { staticClass: "card" }, [
              _c("img", {
                staticClass: "agent-icon",
                attrs: {
                  src: require("@/assets/img/agent/agent.png"),
                  alt: "agent",
                },
              }),
              _c("div", {
                staticClass: "card-title",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("agentIntro.agentApproachTitle")),
                },
              }),
              _c("div", { staticClass: "card-content" }, [
                _vm._v(_vm._s(_vm.$t("agentIntro.agentApproachContent"))),
              ]),
            ]),
            _c("div", { staticClass: "card" }, [
              _c("img", {
                staticClass: "agent-icon",
                attrs: {
                  src: require("@/assets/img/agent/matching.png"),
                  alt: "matching",
                },
              }),
              _c("div", {
                staticClass: "card-title",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("agentIntro.matchingTitle")),
                },
              }),
              _c("div", { staticClass: "card-content" }, [
                _vm._v(_vm._s(_vm.$t("agentIntro.matchingContent"))),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "item-box" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("agentIntro.flowTitle"))),
          ]),
          _c("div", { staticClass: "flow" }, [
            _c("div", { staticClass: "card" }, [
              _c("img", {
                staticClass: "agent-icon",
                attrs: {
                  src: require("@/assets/img/agent/flow1.png"),
                  alt: "flow1",
                },
              }),
              _c("div", { staticClass: "text-block" }, [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.$t("agentIntro.flowStep1Title"))),
                ]),
                _c("div", { staticClass: "card-content" }, [
                  _vm._v(_vm._s(_vm.$t("agentIntro.flowStep1Content"))),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "card" }, [
              _c("img", {
                staticClass: "agent-icon",
                attrs: {
                  src: require("@/assets/img/agent/flow2.png"),
                  alt: "flow2",
                },
              }),
              _c("div", { staticClass: "text-block" }, [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.$t("agentIntro.flowStep2Title"))),
                ]),
                _c("div", { staticClass: "card-content" }, [
                  _vm._v(_vm._s(_vm.$t("agentIntro.flowStep2Content"))),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "card" }, [
              _c("img", {
                staticClass: "agent-icon",
                attrs: {
                  src: require("@/assets/img/agent/flow3.png"),
                  alt: "flow3",
                },
              }),
              _c("div", { staticClass: "text-block" }, [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.$t("agentIntro.flowStep3Title"))),
                ]),
                _c("div", { staticClass: "card-content" }, [
                  _vm._v(_vm._s(_vm.$t("agentIntro.flowStep3Content"))),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "item-box" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("agentIntro.featuresTitle"))),
          ]),
          _c("div", {
            staticClass: "desc",
            domProps: { innerHTML: _vm._s(_vm.$t("agentIntro.featuresDesc")) },
          }),
          _c("div", { staticClass: "feature" }, [
            _c("div", { staticClass: "card" }, [
              _c("img", {
                staticClass: "agent-icon",
                attrs: {
                  src: require("@/assets/img/agent/feature1.png"),
                  alt: "feature1",
                },
              }),
              _c("div", { staticClass: "text-block" }, [
                _c("div", {
                  staticClass: "card-title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("agentIntro.feature1Title")),
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "card" }, [
              _c("img", {
                staticClass: "agent-icon",
                attrs: {
                  src: require("@/assets/img/agent/feature2.png"),
                  alt: "feature2",
                },
              }),
              _c("div", { staticClass: "text-block" }, [
                _c("div", {
                  staticClass: "card-title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("agentIntro.feature2Title")),
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "card" }, [
              _c("img", {
                staticClass: "agent-icon",
                attrs: {
                  src: require("@/assets/img/agent/feature3.png"),
                  alt: "feature3",
                },
              }),
              _c("div", { staticClass: "text-block" }, [
                _c("div", {
                  staticClass: "card-title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("agentIntro.feature3Title")),
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "item-box" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("agentIntro.achievementsTitle"))),
          ]),
          _c("div", {
            staticClass: "desc",
            domProps: {
              innerHTML: _vm._s(_vm.$t("agentIntro.achievementsDesc")),
            },
          }),
          _c("div", { staticClass: "achieve" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "achieve-desc" }, [
                _c("div", [
                  _c("span", { staticClass: "head" }, [
                    _vm._v(_vm._s(_vm.$t("agentIntro.tradingCompaniesHead"))),
                  ]),
                  _c("br"),
                  _c("span", { staticClass: "foot" }, [
                    _vm._v(_vm._s(_vm.$t("agentIntro.tradingCompaniesFoot"))),
                  ]),
                ]),
              ]),
              _c("img", {
                staticClass: "company",
                attrs: {
                  src: _vm.optimizedImage(_vm.detail.partnerCompanyImage.url),
                  loading: "lazy",
                },
              }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "item-box" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("agentIntro.cautionsTitle"))),
          ]),
          _c("div", { staticClass: "caution" }, [
            _c("div", {
              staticClass: "card",
              domProps: {
                innerHTML: _vm._s(_vm.$sanitize(_vm.detail.cautions)),
              },
            }),
          ]),
        ]),
        [
          (_vm.isIntro || _vm.isCampaign) &&
          _vm.isLoadCMS &&
          _vm.isAgentFeatureNotAgreed
            ? _c("div", { staticClass: "item-box no-margin" }, [
                _c("div", { staticClass: "agreement" }, [
                  _c(
                    "button",
                    {
                      ref: "submitButton",
                      staticClass: "button submit",
                      on: { click: _vm.submit },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.detail.ctaBottomBtnText) + " "),
                      _c("span", { staticClass: "arrow" }, [_vm._v("＞")]),
                    ]
                  ),
                  _c("div", {
                    staticClass: "caution-footer",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("agentIntro.cautionFooter")),
                    },
                  }),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "footer-container" },
            [
              _vm.detail.showLinkedNovelCount
                ? _c("FadeFooterButton", {
                    attrs: {
                      isVisibleFooter: _vm.isVisibleFooter,
                      linkedNovelCount: _vm.detail.linkedNovelCount,
                    },
                    on: { "footer-action": _vm.handleFooterAction },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        _c("img", {
          ref: "end",
          staticClass: "cat-hr",
          attrs: { src: require("@/assets/img/event/contest/cat_hr.png") },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }